export enum ViewState {
  ForgottenPassword,
  CheckYourEmail
}
